module.exports = __webpack_public_path__ + "static/img/26.a6cc869f.gif";